var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone"},[_c('div',{staticClass:"phone-screen"},[(_vm.media)?_c('media',{attrs:{"source":_vm.media,"height":"100%","width":"100%"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }